import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

type Preferences = {
  segmentationSideBarCollapsed: boolean
  setSegmentationSideBarCollapsed: (collapsed: boolean) => void
  setSideBarCollapsed: (collapsed: boolean) => void
  sideBarCollapsed: boolean
}

export const usePreferences = create<Preferences>()(
  persist(
    set => ({
      segmentationSideBarCollapsed: false,
      setSegmentationSideBarCollapsed: collapsed =>
        set(() => ({ segmentationSideBarCollapsed: collapsed })),
      setSideBarCollapsed: collapsed => set(() => ({ sideBarCollapsed: collapsed })),
      sideBarCollapsed: false
    }),
    {
      name: "switchPreferences",
      storage: createJSONStorage(() => localStorage)
    }
  )
)
